import { render, staticRenderFns } from "./HeaderEvent.vue?vue&type=template&id=6287638c&scoped=true"
import script from "./HeaderEvent.vue?vue&type=script&lang=js"
export * from "./HeaderEvent.vue?vue&type=script&lang=js"
import style0 from "./HeaderEvent.vue?vue&type=style&index=0&id=6287638c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6287638c",
  null
  
)

export default component.exports